import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import emailjs from '@emailjs/browser';

export default function ContactForm() {
  const { t, i18n } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [countryCode, setCountryCode] = useState('+966'); // Default to Egypt
  const [phoneNumber, setPhoneNumber] = useState('');
  const [isError, setIsError] = useState(false);
  // Common country codes
  const countryCodes = [
    { code: '+966', name: 'Saudi Arabia'},
    { code: '+20', name: 'Egypt'},
    { code: '+971', name: 'UAE'},
    { code: '+965', name: 'Kuwait'},
    { code: '+973', name: 'Bahrain'},
    { code: '+974', name: 'Qatar'},
    { code: '+968', name: 'Oman'},
    { code: '+962', name: 'Jordan'},
    { code: '+961', name: 'Lebanon'},
    { code: '+1', name: 'USA/Canada'},
    { code: '+44', name: 'UK'},
    { code: '+49', name: 'Germany'},
    { code: '+33', name: 'France'},
  ];
  const isRTL = i18n.language === 'ar';
  
  const countryCodeStyle = {
    borderRadius: isRTL ? '8px 0px 0px 8px' : '0px 8px 8px 0px'
  };

  const phoneNumberStyle = {
    borderRadius: isRTL ? '0px 8px 8px 0px' : '8px 0px 0px 8px'
  };
  const sendEmail = (e) => {
    e.preventDefault();
    setIsLoading(true);
    setIsSuccess(false);

    // Create a form data object with the full phone number
    const formData = new FormData(e.target);
    const fullPhoneNumber = `${countryCode} ${phoneNumber}`;
    
    formData.set('phone', fullPhoneNumber);

    emailjs.sendForm(
      "service_yy4fa6v",    
      "template_4clmu9g",   
      e.target,             
      "bg2DjFetbAl7CeLcK"    
    ).then(
      (result) => {
        console.log("Message sent:", result.text);
        setIsLoading(false);
        setIsSuccess(true);
        e.target.reset();
        setPhoneNumber('');
        setCountryCode('+20');
        setIsError(false);
        // Reset success state after 3 seconds
        setTimeout(() => {
          setIsSuccess(false);
        }, 3000);
      },
      (error) => {
        console.error("Error:", error.text);
        setIsLoading(false);
        setIsError(true); 
        
        // Hide error message after 5 seconds
        setTimeout(() => {
          setIsError(false);
        }, 5000);
      }
    );
  };

  return (
    <form className="p-4" onSubmit={sendEmail}>
      <input type="hidden" name="title" value="contact us" />
      
      <div className="mb-4">
        <label htmlFor="name" className="form-label">
          {t('ContactFormName')}
        </label>
        <input
          type="text"
          className="form-control"
          id="name"
          name="name"  
          placeholder={t('ContactFormNamePlaceholder')}
          required
        />
      </div>

      <div className="mb-4">
        <label htmlFor="email" className="form-label">
          {t('ContactFormEmail')}
        </label>
        <input
          type="email"
          className="form-control"
          id="email"
          name="email"  
          placeholder={t('ContactFormEmailPlaceholder')}
          required
        />
      </div>

      <div className="mb-4">
        <label htmlFor="phone" className="form-label">
          {t('ContactFormPhone')}
        </label>
        <div className="input-group">
         
          <input
            type="tel"
            className="form-control"
            id="phone"
            value={phoneNumber}
            onChange={(e) => setPhoneNumber(e.target.value)}
            placeholder={t('ContactFormPhonePlaceholder') || '123456789'}
            style={phoneNumberStyle}
          />
           <select 
            className="form-select"
            value={countryCode}
            onChange={(e) => setCountryCode(e.target.value)}
            style={{ ...countryCodeStyle, maxWidth: '140px' }}
          >
            {countryCodes.map((country) => (
              <option key={country.code} value={country.code}>
                ( {country.code})
              </option>
            ))}
          </select>
          <input type="hidden" name="phone" value={`${countryCode} ${phoneNumber}`} />
        </div>
      </div>

      <div className="mb-4">
        <label htmlFor="subject" className="form-label">
          {t('ContactFormSubject')}
        </label>
        <select className="form-select" id="subject" name="subject">  
       <option value={t('option1')}>{t('option1')}</option>
       <option value={t('option2')}>{t('option2')}</option>
       <option value={t('option3')}>{t('option3')}</option>
       <option value={t('option4')}>{t('option4')}</option>
        </select>
      </div>

      <div className="mb-3">
        <label htmlFor="message" className="form-label">
          {t('ContactFormMessage')}
        </label>
        <textarea
          className="form-control"
          id="message"
          name="message"  
          rows="4"
          placeholder={t('ContactFormMessagePlaceholder')}
        ></textarea>
      </div>

     {/* Error message alert */}
      {isError && (
        <div className="alert alert-danger mb-4" role="alert">
          <i className="fas fa-exclamation-circle mx-2"></i>
          {t('ContactFormError') || 'Failed to send message. Please try again later.'}
        </div>
      )}

      <button 
        type="submit" 
        className="HeroBtn p-3 px-4 w-100 d-flex align-items-center justify-content-center"
        disabled={isLoading}
        style={{ 
          gap: '8px',
          minHeight: '48px',
          opacity: isLoading ? 0.7 : 1,
          backgroundColor: isSuccess ? '#0080E5'  : undefined
        }}
      >
        {isLoading ? (
          <>
            <div className="spinner-border spinner-border-sm" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
            {t('ContactFormSending') || 'Sending...'}
          </>
        ) : isSuccess ? (
          <>
            {t('ContactFormSent') || 'Message Sent!'}
            <i className="fa-regular fa-thumbs-up"></i>
          </>
        ): (
          t('ContactFormSubmit')
        )}
      </button>
    </form>
  );
}